"use client";

import { useEffect, useRef } from "react";
import { isInApp } from "@/lib/app-bridge";

/**
 * PWA/브라우저 환경에서 뒤로가기를 방지하는 훅
 * 네이티브 앱에서는 앱에서 직접 처리하므로 동작하지 않음
 */
export function usePreventBackNavigation() {
  const isHandlingRef = useRef(false);

  useEffect(() => {
    // 네이티브 앱에서는 앱에서 처리하므로 스킵
    if (isInApp()) return;

    // 초기 history state 설정 - 여러 개 push하여 버퍼 생성
    window.history.pushState({ preventBack: true }, "");
    window.history.pushState({ preventBack: true }, "");

    const handlePopState = () => {
      // 중복 처리 방지
      if (isHandlingRef.current) return;
      isHandlingRef.current = true;

      // 앞으로 이동하여 뒤로가기 무효화
      window.history.go(1);

      // 다음 이벤트 처리를 위해 플래그 해제
      setTimeout(() => {
        isHandlingRef.current = false;
      }, 50);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
}
